<template>
  <div>
    <vs-card>
      <b-carousel
        id="carousel-1"
        v-model="slide"
        :interval="3000"
        controls
        indicators
        fade
        background="#ababab"
        img-width="924"
        img-height="380"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <!-- Slides with img slot -->
        <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
        <b-carousel-slide v-for="data in bannerList" :key="data.objectId">
          <template #img>
            <img
              class="d-block img-fluid w-100"
              width="924"
              height="380"
              :src="sistemurl + data.RESIMADI"
              alt="image slot"
            />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </vs-card>
  </div>
</template>

<script>
import { BCarousel, BCarouselSlide, BCardText } from "bootstrap-vue";
import Store from "../../store/store";
import state from "../../store/state";
export default {
  components: {
    BCarousel,
    BCarouselSlide,
    BCardText,
  },
  data: () => ({
    sistemurl: "",
    slide: 0,
    sliding: null,
    bannerList: [],
  }),
  methods: {
    bannerListesi() {
      var vm = this;
      var vs = this.$vs;
      const soap = require("soap");
      let url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        TUR: "Banner",
        DURUM: "Aktif",
      };
      soap.createClient(url, function (err, client) {
        client.B2B_LS_PanelIslem(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.B2B_LS_PanelIslemResult);
            vm.bannerList = vm.veriler;
          } catch (error) {
            console.log(result);
          }

          /* if (result.B2B_LS_PanelIslemResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }*/
        });
      });
    },
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
  },
  created() {
    this.sistemurl = Store.state.imgurl;
    this.bannerListesi();
  },
};
</script>